import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styles from 'modules/Finance/PaymentProfiles/List/payment-profiles.module.scss'
import List from './subcomponents/List'
import FilterPanel from 'components/Filters/FilterPanel'
import config from 'modules/Finance/PaymentProfiles/List/filters'
import useFiltersManager from 'utils/hooks/useFiltersManager'
import PageHeader from 'components/PageHeader'
import { useTranslation } from 'react-i18next'

const PaymentProfiles = () => {
  const [page, setPage] = useState(1)
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const {
    payment_profiles: { data, loading, pagination },
    i18n,
  } = useSelector((state) => ({
    payment_profiles: state['finance/payment-profiles'],
    i18n: state['app'].i18n,
  }))

  const filterManager = useFiltersManager({
    filters: useSelector((state) => state['finance/payment-profiles'].filters),
    config: config(),
    setAction: 'USER/PAYMENT_PROFILES_SET_FILTER',
    localStorageKey: 'payment-profiles',
  })

  useEffect(() => {
    filterManager.params &&
      dispatch({
        type: 'USER/GET_USER_PAYMENT_PROFILES',
        payload: {
          params: {
            ...filterManager.params,
            offset: (page - 1) * pagination.limit,
            limit: pagination.limit,
          },
        },
      })
  }, [filterManager.params, page])

  useEffect(() => {
    dispatch({
      type: 'USER/DROP_USER_PAYMENT_PROFILES',
    })
    setPage(1)
  }, [filterManager.params])

  return (
    <div className={styles['container']}>
      <PageHeader className={'margin-bottom-24'}>{t('payment_profiles::header')}</PageHeader>
      <FilterPanel className={styles['filter-panel']} filterManager={filterManager} />
      <List
        i18n={i18n}
        data={data}
        loading={loading}
        pagination={pagination}
        onChangePage={(val) => setPage(page + val)}
      />
    </div>
  )
}

export default PaymentProfiles
